import React, { useState } from 'react';
import { TooltipContainer, TooltipText } from './style';

interface TooltipProps {
  text: string;
  children: React.ReactNode;
}

const Tooltip: React.FC<TooltipProps> = ({ text, children }) => {
  const [visible, setVisible] = useState(false);

  return (
    <TooltipContainer
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
    >
      {children}
      {visible && text && <TooltipText>{text}</TooltipText>}
    </TooltipContainer>
  );
};

export default Tooltip; 